import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as toastrActions } from 'react-redux-toastr';
import findIndex from 'lodash/findIndex';
import { removeAbnormalityToastr } from '../modules/abnormalities/duck';
import SmallLoader from '../components/SmallLoader';

// PENDING, SUCCESS, ERROR
const eventTypes = type => {
    switch (type) {
        case 'SUCCESS':
            return 'success';
        case 'ERROR':
            return 'error';
        default:
            return 'info';
    }
};

class EventSourceHOC extends React.Component {
    componentDidMount() {
        let reconnectCount = 0;

        this.eventSource = new EventSource(this.props.url);
        const cb = e => {
            console.debug('Show toasts', this.props.toastrs);
            const data = JSON.parse(e.data);
            console.debug('Event received', data);

            const toastrType = eventTypes(data.type); // it will practically always be "success" but catch the cases anyway

            const toastrOptions = {
                timeOut: toastrType === 'success' ? 4000 : 0,
                icon: toastrType === 'info' ? <SmallLoader /> : toastrType,
                status: toastrType,
                showCloseButton: toastrType !== 'success',
                removeOnHover: true,
            };

            this.props.toastr.add({
                id: `${data.id}_${toastrType}`, // important
                type: toastrType,
                title: data.message,
                attention: true,
                position: 'top-right', // do not remove, there is a bug in v.6
                options: toastrOptions,
            });

            const indexSuccess = findIndex(this.props.toastrs, t => t.id === `${data.id}_success`);
            const indexInfo = findIndex(this.props.toastrs, t => t.id === `${data.id}_info`);
            // If pending exists AND succes comes through, remove pending...
            if (indexInfo !== -1 && indexSuccess !== -1) {
                console.debug('Remove toastr', data.id);
                this.props.removeAbnormalityToastr(data.id);
                this.props.toastr.remove(this.props.toastrs[indexInfo].id); // or `${data.id}_info`
            }
        };

        this.props.types.forEach(type => this.eventSource.addEventListener(type, cb, false));

        this.eventSource.onopen = () => console.debug('Event stream opened');
        this.eventSource.onclose = () => console.debug('Event stream closed');
        this.eventSource.onmessage = e => {
            if (this.props.types.indexOf(e.type) === -1) {
                console.debug('Untracked event received', e.data);
            }
        };
        this.eventSource.onerror = e => {
            // Supported by Chrome & Firefox only...
            const src = e.srcElement || e.originalTarget;

            if (src) {
                if (src.readyState === EventSource.CLOSED) {
                    console.debug('Error occured, closing connection');
                } else if (src.readyState === EventSource.CONNECTING) {
                    console.debug('Trying to connect to event stream');
                    reconnectCount++;
                    if (reconnectCount === 10) {
                        this.eventSource.close();
                        console.debug(
                            `[EventSourceHOC] Failed to reconnect after 10 tries, closing ${
                                this.props.url
                            }`
                        );
                    }
                }
            } else {
                console.debug('Event stream error', e);
            }
        };
    }

    componentWillUnmount() {
        console.debug(
            'The event source will now close! (component unmount was called)',
            this.eventSource
        );
        this.eventSource.close();
    }

    render() {
        return null;
    }
}

EventSourceHOC.propTypes = {
    url: PropTypes.string.isRequired,
    types: PropTypes.array,
};

EventSourceHOC.defaultProps = {
    types: ['message'],
};

const mapDispatchToProps = dispatch => ({
    toastr: bindActionCreators(toastrActions, dispatch),
    removeAbnormalityToastr: bindActionCreators(removeAbnormalityToastr, dispatch),
});

export default connect(state => ({ toastrs: state.toastr.toastrs }), mapDispatchToProps)(
    EventSourceHOC
);
